export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-collection/src/keys.js
// module id = 240
// module chunks = 0 1 2 3 4